import { render, staticRenderFns } from "./Arquivo.vue?vue&type=template&id=745b10c4"
import script from "./Arquivo.vue?vue&type=script&lang=js"
export * from "./Arquivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports